import FieldConfig from "../../../../fields3/proto/field-config";
import FieldDropdown from "../../../generic/dropdown/dropdown";
import ProjectSession from "../../../../model2/project/project-session";
import FieldProjectTemplate_PopoverOption from "./component/option/option";
import FieldProjectTemplate_FormValueNotEmpty from "./component/form/value-not-empty";

export default class FieldProjectTemplate extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Project Type"
        this.icon           = 'i5-task-types'

        this.showMenuMore   = false

        if (!config.options || config.options.length === 0) {

            this.options = []

            gd.session.templatesList.map((projectSession: ProjectSession)=> {
                this.options?.push({
                    value: projectSession.id,
                    label: projectSession.name
                })
            })
        }

        this.components.PopoverOption = FieldProjectTemplate_PopoverOption
        this.components.FormValueNotEmpty = FieldProjectTemplate_FormValueNotEmpty

    }

    getViewValue(model:any) {
        // hm a pochemu v model netuy ?
        return model[this.fieldId] ? model[this.fieldId] : gd.session.projects.get(model.id)!.localTemplateId;
    }
}
